import React,{useEffect,useState} from "react";
import styles from "./index.module.css";
import { observer } from "mobx-react-lite";
import UserAvatar from "./userAvatar";
import UserInfoStore from "../../store/userInfoStore";
import { getJump } from "../../api/map"
import { Link,NavLink  } from "react-router-dom"

const Header = (props) => {
  const userInfo = UserInfoStore.getUserInfo();
  const token = localStorage.getItem("token");
  const [url,setUrl] = useState('')
  
    useEffect(() => {
      getJump().then((res) => {
        setUrl(res.result);
      });
    }, []);
  return (
    <header className={styles.wrap} style={{padding:10}}>
      <div className={styles.content}>
        <div className={styles.main} style={{display:'flex',flexDirection:'row'}}>
          <div className={styles.nav} style={{paddingTop:20 }}>
            <NavLink   style={({isActive})=>{return isActive ? { color: "#f00" }:{color:"#fff"}}} to='/'>首页</NavLink >
            <NavLink   style={({isActive})=>{return isActive ? { color: "#f00",marginLeft:20 }:{color:"#fff",marginLeft:20 }}} to='/product'>作品展示</NavLink >
          </div>
          <div style={{paddingTop:20 }}><a href={url} target="_blank" style={{color:"#fff"}}>AI设计</a></div >      
        </div>
         <div style={{ color: "#fff",fontWeight:'bold',fontSize:'24px', cursor: "default",textAlign:'center',flex:1,marginTop:-10 }}>
            贵州省民间文艺作品版权资源数据库<br/><span style={{textAlign:'center'}}></span>
          </div>
        <div className={styles.main}>
          <div>{token ? <UserAvatar /> : <Link className={styles.avatar} to='/login'>登录</Link>}</div>
        </div>
      </div>
    </header>
  );
};
export default observer(Header);
